const PREFIX = 'EPG';

export const SHOW = `${PREFIX}/SHOW` as const;
export const HIDE = `${PREFIX}/HIDE` as const;

export const LOAD_EPG = `${PREFIX}/LOAD_EPG` as const;
export const LOAD_EPG_SUCCESS = `${PREFIX}/LOAD_EPG_SUCCESS` as const;
export const LOAD_EPG_ERROR = `${PREFIX}/LOAD_EPG_ERROR` as const;

export const LOAD_EXTRA_EPG = `${PREFIX}/LOAD_EXTRA_EPG` as const;
export const LOAD_EXTRA_EPG_SUCCESS = `${PREFIX}/LOAD_EXTRA_EPG_SUCCESS` as const;
export const LOAD_EXTRA_EPG_ERROR = `${PREFIX}/LOAD_EXTRA_EPG_ERROR` as const;
